import { Exclude, Expose } from 'class-transformer';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { BoardPurchaseFlowRuleInterface } from '../interfaces/board-purchase-flow-rule.interface';
import { BoardPurchaseFlowRuleDirectionEnum } from '../enums/board-purchase-flow-rule-direction.enum';
import { BoardPurchaseDto } from '../../board-purchase/dto/board-purchase.dto';
import { JobPhaseDto } from '../../job-phase/dto/job-phase.dto';
import { IntersectionType } from '@nestjs/swagger';
import { FlowRuleCommonDto } from '../../flow-rule-common/dto/flow-rule-common.dto';

@Exclude()
export class BoardPurchaseFlowRuleDto
  extends IntersectionType(CommonEntityDto, FlowRuleCommonDto)
  implements BoardPurchaseFlowRuleInterface
{
  @Expose()
  direction!: BoardPurchaseFlowRuleDirectionEnum;
  @Expose()
  jobPhaseId!: string;
  @Expose()
  jobPhase?: JobPhaseDto;
  @Expose()
  boardPurchaseId!: string;
  @Expose()
  boardPurchase?: BoardPurchaseDto;
}
